import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import styled, { withTheme } from 'styled-components';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { SideBarObjects as adminSideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { destroyCurrentUserSession } from 'services/users/duck';
import { UNIFIED_NAV_VIEW } from 'constants/capabilities';
import EntityHomeSearchContainer from 'containers/EntityHomeSearchContainer';

const ENTITIES_TO_SHOW_SEARCH = 5;
const INDENT_PADDING = 20; // padding for the hierarchy depth

const HierarchyIconWrap = styled.div`
    color: #AFAFAF;
    float: left;
    font-size: 13px;
    height: 20px;
    margin: -2px 5px;
    padding-left: ${props => props.depth * INDENT_PADDING}px;
`;

const LinkWrapper = styled.div`
    padding: 8px 0px 8px 20px;
    font-size: 15px;
    border: solid 1px #E8E8E880;
    border-left: none;
    border-right: none;
`;

const HomeHeader = styled.div`
    background-color: #F1F1F1;
    padding: 8px 0px 8px 20px;
    text-transform: uppercase;
    font-size: 16px;
    border-bottom: solid 1px #AFAFAF;
`;

const ContentWrapper = styled.div`
    border: solid 1px #AFAFAF;
    overflow: hidden;
    border-radius: 5px;
    margin-bottom: 15px;
`;

class HomeContentContainer extends Component {
    render() {
        const { userEntities, isOkta, userId, userScope } = this.props;

        const hasUnifiedNavView = userScope.includes(UNIFIED_NAV_VIEW);

        const resourceLinks = [
            <Link key={'glossary'} to={'/glossary'} title="Go to Glossary">
                <LinkWrapper>Glossary</LinkWrapper>
            </Link>
        ];

        for (const link of adminSideBarObjects) {
            const { scope, path, name, type } = link;
            let hasAccess = true;
            for (const capability of scope) {
                if (userScope.includes(capability) === false) {
                    hasAccess = false;
                    break;
                }
            }

            if (hasAccess && type === 'link') {
                resourceLinks.push(
                    <Link key={name} to={path} title={`Go to ${name}`}>
                        <LinkWrapper>{name}</LinkWrapper>
                    </Link>
                );
            }
        }

        return (
            <Grid fluid>
                <Row className="hidden-print">
                    <Col sm={12} md={7}>
                        <ContentWrapper>
                            <HomeHeader>{isOkta ? 'Your Dashboards' : 'Favorite Dashboards'}</HomeHeader>
                            {userEntities.length ? [
                                userEntities.length > ENTITIES_TO_SHOW_SEARCH ? <EntityHomeSearchContainer key={'search'} /> : null,
                                userEntities.map((entity, index) =>
                                    <LinkWrapper key={index}>
                                        <Link to={`/dashboard/${entity.id}/summary`} title="Go to Dashboard">
                                            {entity.depth > 0 ? [
                                                <HierarchyIconWrap key={0} depth={entity.depth} className="icon-hierarchy" />,
                                                <span key={1}> {entity.label} </span>
                                            ] :
                                                <span>{entity.label}</span>
                                            }
                                        </Link>
                                    </LinkWrapper>
                                )
                            ] :
                                <LinkWrapper>
                                    {isOkta ?
                                        <React.Fragment>
                                            You do not have any dashboards on your favorites list.{' '}
                                            <Link to={`/admin/users/${userId}/edit`} title="Go to Your Profile">Add Dashboards</Link>
                                        </React.Fragment>
                                        : 'You are currently not assigned to any dashboards.'}
                                </LinkWrapper>}
                        </ContentWrapper>
                    </Col>
                    <Col sm={12} md={5}>
                        <ContentWrapper>
                            <HomeHeader>Resources</HomeHeader>
                            {resourceLinks}
                        </ContentWrapper>
                        {!hasUnifiedNavView ?
                            <ContentWrapper>
                                <HomeHeader>Account</HomeHeader>
                                <a href="#" onClick={this.props.destroyCurrentUserSession}>
                                    <LinkWrapper>Logout</LinkWrapper>
                                </a>
                            </ContentWrapper>
                            : null
                        }
                    </Col>
                </Row>
            </Grid>
        );
    }
}

const mapStateToProps = state => ({
    userEntities: get(state, 'users.currentUser.userEntities', []),
    isOkta: get(state, 'users.currentUser.isOkta', false),
    userId: get(state, 'users.currentUser.id', null),
    userScope: get(state, 'users.currentUser.scope', [])
});

export default connect(mapStateToProps, { destroyCurrentUserSession })(withTheme(HomeContentContainer));



// WEBPACK FOOTER //
// ./src/containers/home/HomeContentContainer.js